import type { AccountState } from './types';

export const accountInitialState: AccountState = {};
